// 该文件为自动生成，请不要直接修改该文件(直接修改该文件,送翻后修改会失效)
/* eslint-disable */
export default {
  "3259583117": "Müşteri yönlendirmesi bildirimi",
  "1d484fee4a": "Finans Departmanı, Satış Departmanı, Proje Yönetimi, İş Verileri, Ürün Departmanı, Operasyon Departmanı, Ar-Ge Yönetimi, Sürüm Planlaması, Müşteri Hizmetleri Departmanı, İdari İşler Departmanı, Satın Alma Departmanı, Satış Sonrası Yönetimi",
  "a2c88dfb79": "İlk takımınızı oluşturun",
  "3cfdcc6086": "Finans Departmanı, Satış Departmanı, Proje Yönetimi/305, İnsan Kaynakları ve İdari İşler/306, Operasyon Departmanı, Ar-Ge Yönetimi, Sürüm Planlaması, Müşteri Hizmetleri Yönetimi/403, Satın Alma Departmanı, Satış Sonrası Yönetimi",
  "ac45ec2c05": "Hesap giriş doğrulaması başarısız",
  "9aef9b8ccd": "Mevcut hesabın oturum açma durumu anormal, lütfen hesap oturumunu kapatıp yeniden deneyin",
  "728dd00f22": "Bu telefon numarası doğrulaması anormal, lütfen SMS doğrulama koduyla giriş yapın",
  "30dbecd916": "Doldurduğunuz bilgilerde hassas kelimeler var, lütfen düzelttikten sonra yeniden deneyin",
  "12ed508d8a": "Çok sık işlem yapıyorsunuz, lütfen biraz sonra tekrar deneyin",
  "952d4a7595": "Mevcut hesabın oturum açma durumu anormal, lütfen hesap oturumunu kapatıp yeniden deneyin",
  "e64bfdeaa4": "Giriş doğrulaması başarısız, lütfen SMS doğrulama kodunu yeniden alın",
  "79008a65f1": "Bu telefon numarası birden fazla şirkete katıldı, lütfen şirkete giriş yapın veya telefon numarasını değiştirin",
  "bf242eff42": "Şirket adı zaten mevcut",
  "4f0cdb8374": "Eksiksiz bir telefon numarası giriniz, denizaşırı bir numara kullanıyorsanız, lütfen yurt içi numara (86+) ile değiştiriniz",
  "46e79ffeff": "Şirket oluşturma hatası, lütfen resmi müşteri hizmetleriyle iletişime geçin",
  "f3e18f0341": "Parametre doğrulama başarısız",
  "503fd1718d": "SMS doğrulama kodu gönderimi başarısız",
  "24b3129f19": "SMS gönderimi çok sık, lütfen biraz sonra tekrar deneyin",
  "1cde3e8245": "Doğrulama kodu hatalı, lütfen yeniden girin",
  "4212ecc031": "Birçok doğrulama hatasına maruz kaldınız, doğrulama kısıtlandı, lütfen biraz sonra tekrar deneyin",
  "735da9c347": "Şirket adı benzeri doğrulama hatası, lütfen resmi müşteri hizmetleriyle iletişime geçin",
  "8731da9615": "Şirket adı doğrulama hatası, lütfen resmi müşteri hizmetleriyle iletişime geçin",
  "62e89b3f16": "Hizmet sözleşmesini kabul et",
  "c9b79027e5": "Doğrulama kodu gönder",
  "84c1447b9d": "Kopyalama başarılı",
  "fba4b0abd0": "Ana Bilgisayar Kaydı",
  "37f5a7cd41": "TXT Değeri",
  "78b12427c9": "Doğrulama sürüyor...",
  "59d089837c": "Şu anda alan adınızı doğrulayamıyoruz, alan adı sağlayıcınızın bilgilerinizi güncellemesi için biraz daha beklemeniz gerektiğini belirtmek isteriz. Bir süre sonra yanıt alamazsanız, yeniden doğrulamayı veya alan adını değiştirmeyi deneyin.",
  "4a5b7383d1": "Domain Adını Kontrol Ediyor",
  "f24a492e40": "Doğrulama kaydını kapatabilirsiniz ve daha sonra tekrar gelip kontrol edebilirsiniz.",
  "c697ca5f1a": "Kurumsal Sürümü Hoş Geldiniz",
  "ebb01b1740": "Sonraki Adım",
  "30109bf753": "Şirketinizin bir alan adı var mı?",
  "2b3e485b47": "Şirket Alan Adım Var",
  "1a7f5eae44": "Şirket Alan Adım Yok",
  "bde15d6d84": "Kurumsal hesap oluşturabilmemiz için bir alan adına (örneğin: example.com) sahip olmanız gerekiyor.",
  "07ffb22c90": "Üzgünüz, kurumsal hesap oluşturulabilmesi için bir alan adınızın olması gerekiyor.",
  "de23836563": "Kurumsal hesap oluşturmak için kullanılacak alan adını girin",
  "287c07944a": "Alan Adınızı Doğrulayın",
  "3ea2d528d5": "Aşağıdaki adımları tamamlayarak <b>{domain}</b> alan adının sahibi olduğunuzu kanıtlayabilir ve başka hiçbir kişinin bu alan adını kurumsal hesap oluşturmak için kullanmasını engelleyebilirsiniz.",
  "082b18ce56": "a. <b>Yeni Sekme</b> açarak alan adı barındırma sağlayıcısının web sitesine gidin ve <b>giriş yapın</b>.",
  "4f7e0841a9": "b. Alan adı barındırma sağlayıcısının web sitesinde, <b>DNS Kayıtları Bölümüne</b> gidin. Alan adı barındırma sağlayıcısının web sayfasında, DNS kayıtları bölümünün adı farklı olabilir, örneğin <b>DNS Yönetimi, Ad Sunucu Yönetimi, Kontrol Paneli veya Gelişmiş Ayarlar</b> olarak görüntülenebilir.",
  "6365ad6e3a": "Daha sonra, <b>buraya geri dönün</b> ve doğrulama kaydını eklemek için \"Sonraki Adım\" ı tıklayın.",
  "8528892080": "Doğrulama Kaydını Ekle",
  "7a225304f8": "a. DNS sayfasında, <b>TXT</b> bölümüne gidin ve kayıt eklemek için ilgili düğmeye tıklayın.",
  "b3cb7d947c": "b. Aşağıdaki tüm değerleri alan adı barındırma sağlayıcısının web sitesindeki <b>TXT formuna</b> <b>kopyalayıp yapıştırın</b>.",
  "47213583bf": "c. <b>Kaydet</b> alan adı barındırma sağlayıcınızın sitesindeki kayıtları,<br>sonra <b>buraya dönün</b> ve aşağıdaki \"Alan Adını Doğrula\" düğmesine tıklayın",
  "21486a57cf": "Not: Name/Host/Alias alanında ' @ ' yazabilirsiniz ya da boş bırakabilirsiniz. Domain barındırıcı ayrıca alan adı (<SizinAlanAdınız>.com) girmenizi isteyebilir. Diğer DNS kayıtlarına bakarak bu alanı nasıl dolduracağınızı belirleyebilirsiniz. TTL alanına '86400' yazın veya varsayılan değeri bırakın.",
  "f1b8edab9c": "Alan Adını Değiştir",
  "7c6fc663a8": "Alan Adını Doğrula",
  "b6aee9dc0d": "Alan Adı Başarıyla Doğrulandı",
  "dd4cc429ea": "Siz",
  "450f5c9230": "sahipsiniz ve başkasının bu alan adını işletme hesabı için kullanmasını engellediniz.",
  "71cbcba755": "İşletme hesabı oluşturmayı tamamlamak için 'Sonraki Adım' butonuna tıklayın.",
  "f4084f4870": "Giriş hesap bilgilerinizi ayarlayın",
  "fe3138baec": "Oluşturmayı Tamamla",
  "0315cddedb": "İşletme Başarıyla Oluşturuldu",
  "91454a7f34": "Şimdi, işletme üyeleriniz için işletme hesapları oluşturmak üzere yönetim paneline giriş yapın.",
  "366304cde7": "1. Şu anda oturum açılmış olan WPS hesabından otomatik olarak çıkış yapacaktır",
  "8a9f2a8422": "2. Yönetim paneline giriş yapmak için şirket hesabınızı kullanmanız gerekmektedir {account}@{domain}",
  "43e265e998": "Yönetim Paneline Giriş Yapın",
  "9240efaaf0": "SMS gönderildi",
  "e424bb9a6d": "Lütfen giriniz",
  "d44d581706": "İşletme Adı",
  "aa8679f406": "4~30 karakter",
  "581bdb1f98": "Özel semboller \\ / : * ? \" <> | {} içermemelidir",
  "c13cabb67a": "E-posta",
  "2b9b429e46": "E-postanız",
  "5ed834a7df": "Lütfen e-posta adresinizi girin",
  "acfd1f02ed": "Lütfen doğru e-posta adresini girin",
  "31c7c92cca": ", maksimum 80 karakter",
  "3f27cf84b3": "Doğrulama kodunu girin",
  "a0ae1f3ec4": "Doğrulama kodu yanlış",
  "e5589c5e74": "Adınız",
  "69d7bd63f6": ", sadece Çin alfabesi, harf ve rakam girebilirsiniz",
  "91f008d258": ", maksimum 8 karakter",
  "6ea6c9b39b": "Telefon Numarası",
  "161042c5b7": "Telefon numaranızı girin",
  "e6b8eab1cd": "Lütfen 11 haneli telefon numarasını girin",
  "3fd5fbb3cc": "Alan adınızı girin",
  "cb5346ba8e": "Lütfen doğru şirket alan adını girin, 4~30 karakter",
  "27928eb7a4": "Hesap",
  "8e19bd444d": "Giriş için kullanılacak hesap adını girin",
  "7bbbf479dc": "4-20 karakter, sadece rakam, harf veya alt çizgi",
  "3d84cae479": "Lütfen gereksinimleri karşılayan bir hesap girin/ilk karakter harf veya sayı olmalıdır",
  "c0d5ece1a7": "Şifre",
  "f444036fa8": "Lütfen şifrenizi girin",
  "b03218d72b": "Şifre 12-16 karakter uzunluğunda büyük/küçük harf, rakam veya 3 kombinasyon içeren olmalıdır",
  "b4ab05df50": "Şirketinizden birisi alan adınızı kurumsal hesap için kullanıyor, lütfen bu alan adının sahibi olduğunuzu kanıtlamak için müşteri hizmetleri (400-677-5005) ile iletişime geçin.",
  "c58876008f": "Kopyalama başarısız oldu, lütfen tekrar deneyin",
  "86f73420de": "Davet Linki",
  "a58861962c": "Üzgünüz, mevcut tarayıcınız bu QR kodunu indirmenizi desteklemiyor",
  "228db07f78": "Finans Departmanı, Satış Departmanı, Proje Yönetimi, İş Verileri, Ürün Departmanı, Operasyon Departmanı, Ar-Ge Yönetimi, Sürüm Planı, Müşteri Hizmetleri, İdari Departman, Satın Alma Departmanı, Satış Sonrası Yönetim",
  "93896d7e98": "Takımı oluşturduktan sonra, meslektaşlarınızla işbirliğine başlayın",
  "e8f66fb75c": "Finans Departmanı, Satış Departmanı, Proje Yönetimi/305, İşçi İlişkileri/306, Operasyon Departmanı, Ar-Ge Yönetimi, Sürüm Planı, Müşteri Hizmetleri/403, Satın Alma Departmanı, Satış Sonrası Yönetim",
  "831b73da9b": "Adınız yasadışı karakterler ve özel semboller içermemelidir /\\;:*?\"<>|%&",
  "51ab33b3ee": "Parametre yanlış",
  "a297f9e951": "Şirket adı zaten mevcut",
  "04d60ed5f5": "Yasaklanmış kelimeler kullanılamaz",
  "2ff7bef083": "Alan adı formatı hatalı",
  "41e1ba2165": "Alan adı TXT bilgilerini doğrulama başarısız oldu",
  "50f348caa9": "Hesap zaten mevcut",
  "9d4c950d65": "Bu isim zaten kayıtlı ve kullanılmakta",
  "38cf19ed95": "Bu kurum adı zaten mevcut",
  "4b426e7c9c": "Kurum adı",
  "298f880e18": "Zaten mevcut, daha fazla bilgi eklemeniz önerilir:",
  "1e67dd20b3": "Kurum adını bulun",
  "517107cb04": "Başka bir isim kullan",
  "5667081882": "Bu isimle oluştur",
  "e306a979a6": "Hızlı doldur:",
  "f583db96e0": "*Kurum adı kullanılıyorsa",
  "9767148e34": "Lütfen şirket veya organizasyon adını girin, 4~100 karakter",
  "e0e0ec159f": "Kurum Adı",
  "5b13d254c0": "Bu şirket adı zaten mevcut",
  "92027671ec": "Şirket adı",
  "36d482a7fb": "Şirket adını bulun",
  "79058a7577": "*Şirket adı kullanılıyorsa",
  "c96dd48dba": "Şirket adı",
  "842efad336": "*Eğer şirket çalışanıysanız, lütfen",
  "860f9bd77b": "Müşteri hizmetleri ile iletişime geçin",
  "5a7ed18daf": "Şirkete katıl",
  "ab470e9ace": "İletişim bilgilerinizi bırakın",
  "0a7e0e48a7": "Başvurduğunuz şirket adı:",
  "a8dc318dcc": "Lütfen doldurduğunuz iletişim bilgileri doğrulayın, platform müşteri hizmetleri yakında sizi arayacaktır",
  "6ea1f4d7f5": "Bilgileri gönder",
  "d439e39f43": "Bilgileriniz alındı",
  "884653426b": "Müşteri hizmetleri 24 saat içinde sizi arayacak, lütfen telefonu dikkatle yanıtlayın!",
  "2361cb14bf": "Durumu öğrenmek için çevrimiçi müşteri hizmetleri ile iletişime geçmek üzere WeChat kodunu tarayın",
  "50f45d0031": "Kaydetme Başarısız",
  "fc856d0fd2": "Süper Yönetici",
  "e16c0676d2": "Yönetici",
  "b1d2ddd126": "Normal Üye",
  "9d322cc08d": "Kuruluş İsminde Özel Semboller Bulunamaz \\/:*?\"<>|{}.",
  "b583ba7363": "Şirket İsminde Özel Semboller Bulunamaz \\/:*?\"<>|{}.",
  "1d118a9bad": "Kuruluş adı en az 4 karakter olmalıdır, lütfen 4 ila 100 karakter arasında bir kuruluş adı girin",
  "441b45b1f5": "Firma adı en az 4 karakter olmalıdır, lütfen 4 ila 100 karakter arasında bir firma adı girin",
  "97457cb1f0": "Kuruluş adı 100 karakteri aştı, lütfen 4 ila 100 karakter arasında bir kuruluş adı girin",
  "8ce00d3b92": "Firma adı 100 karakteri aştı, lütfen 4 ila 100 karakter arasında bir firma adı girin",
  "a72778d3de": "İsim en az 2 karakter olmalıdır, lütfen 2 ila 10 karakter arasında bir isim girin",
  "79c17db5de": "İsim 10 karakteri aştı, lütfen 2 ila 10 karakter arasında bir isim girin",
  "482a118202": "İsim Sadece Çince Karakterler, Sayılar, İngilizce ve · ile Desteklenir.",
  "9a9be18941": "Lütfen işaretleyin",
  "e6b7c4aa66": "Çevrimiçi Hizmet Sözleşmesi",
  "595023d905": "Kuruluş Oluştur",
  "ba8c2df551": "Kuruluş Oluştur",
  "d284384975": "Çevrimiçi Hizmet Sözleşmesi",
  "5c266d5a84": "Gizlilik Sözleşmesi",
  "fcb92dbcf6": "Bulut Ofis Hizmet Sözleşmesi",
  "2ae7a8a3f7": "WPS 365 Bulut Ofis Hizmetini tercih ettiğiniz için teşekkür ederiz. Aşağıda, sizin ve/veya temsil ettiğiniz kuruluş ile Kingsoft Office arasında bu hizmetin kaydı, abonesi olma ve kullanımına ilişkin yasal anlaşma anlatılmaktadır.",
  "d30a6983bd": "Lütfen {0} | {1} | {2} okuyun ve 'Kabul et' e tıklayarak, bu anlaşmanın içeriğine ve hizmetimize kabul ettiğiniz sayılır.",
  "263e306ede": "{0} | {1} | {2} okudum ve Kabul ediyorum",
  "440129c0f1": "{0} giriniz",
  "8ab916983d": "Kuruluş Adı",
  "b01d68543b": "Adınız",
  "684b30d4e9": "Telefon Numaranız",
  "a48427e8e2": "Kuruluşunuza ait çalışma platformunu oluşturmak için kullanılır",
  "3a81b0f1fc": "Sistemde sizi bulmak ve iş birliği yapmak için iş arkadaşlarınıza kolaylık sağlar",
  "52bc539b6e": "Oluşturmayı Onayla",
  "b2fe245e19": "Şirket/Ekip Kurma: Dosya Paylaşımı ve İşbirliği",
  "893282d3f7": "Lütfen kuruluş bilgilerini tamamlayın:",
  "cc997bf6aa": "Onayla",
  "50fdde51ac": "{0}, {1}~{2} karakter",
  "a19cc5ec18": "{0}, özel karakterleri içermemeli \\u005C/:*?\"<>|{}",
  "26857f28f9": "{0}, yalnızca Çince karakterler, harfler ve rakamlar kabul edilir",
  "f4080b1431": "{0}, en fazla {1} karakter",
  "88e59b2d58": "{0}, 11 haneli sayı",
  "91d6d4e105": "Lütfen doğrulama kodunu girin",
  "bec71bde96": "Doğrulama kodu yanlış",
  "e20ff8ee19": "{0} gereklidir",
  "8dc09d10d7": "dwId bulunamadı",
  "a03766ce6c": "Okul",
  "03542addfe": "Şirket",
  "adb8a815d1": "Telefon numarası bağlama {0} sınırına ulaştı",
  "97a6b66f1d": "Geçerli telefon numarası zaten {0} ile bağlı",
  "665e465487": "{0} oluşturulamıyor, mevcut cep telefonu numarası \"<strong>{1}</strong>\" bağlı {0} sayısı üst sınıra ulaştı (en fazla 5 {2} bağlanabilir), aşağıdaki bağlı {3} bölümüne gidebilirsiniz:",
  "a85b1367ca": "Mevcut cep telefonu numarası \"{0}\" {1} bağlı, mevcut {2} ile giriş yapabilir veya yeni {3} oluşturabilirsiniz:",
  "bf992ce17b": "Başka telefon numarası kullanarak {0} oluştur",
  "395ea04444": "Yeni {0} oluştur",
  "4ce3bb86b3": "Katılım {0} sayısı sınırını aştı",
  "df88c4b7a5": "Mevcut cep telefonu numarası \"{0}\" bağlı {1} sayısı üst sınıra ulaştı",
  "78f7dd59ca": "Mevcut cep telefonu numarası \"{0}\" aşağıdaki {1} bağlı, doğrudan geçiş yaparak kullanabilirsiniz",
  "8db491a3f8": "Yeni {0} oluşturulmaya devam ediliyor",
  "83f6d9e1e4": "Bir kez daha",
  "1dc5f11612": "veya",
  "217d76f53e": "Geri bildirim",
  "b69a6ea62a": "Lütfen fare sol tuşunu basılı tutun ve iki kalkanı ortaya çıkarın",
  "3a31f64800": "Tebrikler, kalkanı başarıyla ortaya çıkardınız<br/>Devam etmek için bir sonraki adımı gerçekleştirin",
  "6a81fcee96": "Yükleniyor",
  "e97877a65d": "Ah, kalkan kayboldu<br/>Lütfen",
  "8d85456145": "Çok bekledim<br/>Lütfen",
  "77ad847b95": "Ağ gerçekten zayıf<br/>Lütfen",
  "dbd1ae3a34": "Çok hızlı kazıdınız<br/>Lütfen",
  "bd8e05cd53": "Akıllı doğrulamayı başlatmak için düğmeye tıklayın",
  "63d2a8a722": "Doğrulama başarılı",
  "73141928ad": "Doğrulama başarısız oldu, yenilemek için düğmeye tıklayın",
  "04856c5c8a": "Akıllı algılama devam ediyor",
  "52cd9bd26d": "İşleminiz yetkisiz",
  "fd157e8ea8": "Oluşturma kılavuzu",
  "c6225c5b2b": "Kurumsal versiyonu kullanmaya hoş geldiniz",
  "e33423fb1e": "Oluşturma başarılı",
  "7b0c035999": "WPS Docs kurumsal oluşturma sayfası başarıyla tamamlandı",
  "85db8faae0": "Kurumsal versiyon kullanım kılavuzu",
  "20591b9b44": "Kurumsal adını geri al",
  "b023d76dc2": "Üye yükleme kılavuzu",
  "e2f454e095": "{0}'nın kurumu",
  "df466f942b": "Şube",
  "26a7b797c4": "Alt merkez",
  "5fc82b360b": "Tek durak ofis hizmet platformu, daha verimli çalışmanız için",
  "f2e736d52e": "Kurumsal versiyonu kullanmaya hoş geldiniz",
  "becc41a35b": "Kurumsal adı",
  "74685cdc58": "Lütfen kurum veya organizasyon adını 4-100 karakter arasında giriniz",
  "07b55b1907": "Şirket Ölçeği",
  "77b2f763ad": "Lütfen Şirketinizin Ölçeğini Seçin",
  "49d2509109": "5 Kişiden Az",
  "8db2c9b74a": "6-20 Kişi",
  "a9fb0cf14a": "21-50 Kişi",
  "0fed41f8d3": "51-100 Kişi",
  "fb33f25a04": "101-200 Kişi",
  "3e3ff0f52e": "201-500 Kişi",
  "cd8b51f634": "501-2000 Kişi",
  "0662fa6eec": "2000 Kişiden Fazla",
  "69334dba1a": "Şirket İhtiyaçları",
  "79994e749c": "(En İyi Sektörel Çözüm Önerisi Sunulacaktır)",
  "840a017f38": "Çözmek İstediğiniz Problemi Seçin",
  "f045b05c73": "Şirket Kurma İhtiyaçlarınızı Girin",
  "d8efb0b36d": "Diğer",
  "adcb8fbb0c": "Sık Kullanılan Telefon Numarası",
  "eb1c73e2ca": "Sık Kullandığınız 11 Haneli Telefon Numaranızı Girin",
  "7f276e7dfa": "Ücretsiz Oluştur",
  "c391b3eec1": "SMS Gönderimi Başarısız",
  "54f4cb8fa7": "SMS Gönderildi",
  "231eb1fa1e": "Kurumsal Kullanıcı {0}",
  "272b0f9d32": "Şirket Kullanıcısı",
  "b209a67331": "Şirket Oluşturma Başarısız, Lütfen Sayfayı Yenileyin.",
  "acb08d0cc9": "Şirket Oluşturmanın Üçüncü Adımı",
  "83db361f51": "Tamamlama Sonrası Yönlendirme İşlemini Tetikler",
  "1e930326e3": "handleStep Bir Sonraki Adıma Geç",
  "184df5c725": "saveForm Başarısız",
  "736eab3023": "Doğrulamayı Gönder",
  "2db62dc13c": "Doğrulama Başarısız",
  "54fb0afaea": "Doğrulama Başarılı",
  "d39cff3fcf": "Ekstrem Kaydetme Durumunu Geçerek Yalnızca Doğrulama Kodu Gerektiği Duruma Geç",
  "305b777ae5": "\"Şirket İsmi Alındı\" Penceresi ve İsmi Kaydedin Hatası Başarısız Oldu",
  "e57b6686b2": "Doğrulama Konusunun Sertifika Alıp Almadığını Kontrol Edin, Sertifika Koruma Uyarısı ve Sertifika Bilgilerini Saklayın",
  "f7c86f496d": "İsim Tekrarlama veya Doğrulama Kodu Gecikmişse, Yeni İsimle Kaydederek Devam Edilmez",
  "cb37db4fd4": "handleSubmit Başarısız",
  "243a569fc4": "Bu İsim Zaten Kayıtlı, Lütfen Başka Bir İsim Kullanın",
  "196851a3d9": "Kurumsal Kullanıcı {0}",
  "0c3a3595ff": "Şirket Kullanıcısı",
  "a33b41e0f2": "Şirket Oluşturma Başarısız, Lütfen Sayfayı Yenileyin.",
  "fcce6a7156": "Başarıyla Oluşturuldu",
  "5ec6da58a6": "İstemciyi Bildir",
  "259c9dfa4e": "Profesyonel Sürüm Mantığı",
  "864156930f": "vba Mantığı",
  "7824efd172": "WPS Office Mobil",
  "52b6cfaaaf": "wps İstemcisi",
  "c7c51beea9": "Eğitim Sürümü",
  "8d054d4986": "Varsayılan İstemci",
  "b597e18fb1": "isWps365PcClient ve açık URL",
  "b0c13de2a0": "isWps365PcClient veya client değil, açık URL",
  "7d0f2ce18c": "isWps365PcClient veya client değil, açık URL başarı geri çağrısı",
  "e2c5a07df6": "client olmayan openurl olmayan",
  "29e0414d1f": "client olmayan openurl olmayan geri çağırma",
  "60861f7d2a": "AutoChange İş Birimine Kendiniz Değiştirin",
  "7c83140d90": "Misafir durumu oluşturma, sdk hesap değiştirme gerekmiyor (sdk misafiri desteklemiyor), code zaten arayüzü değiştirmeyi başardı",
  "3379b09e59": "openurl ve href kullanılarak değiştiriliyor",
  "586ff04c22": "Tek başına yönlendir",
  "b6c91f218b": "useSuccessSkip başarısız",
  "47d2f3ba66": "Diğer",
  "57551f86ce": "Farklı Yönlendirme Yöntemlerini Uygula UTM Kaynağına Göre",
  "64fe3758e2": "Eyleminiz yetkisiz",
  "4da3e1262f": "Başarıyla oluşturuldu, kurumsal ofis yolculuğuna başlayın",
  "c38dfb8c6c": "İlk ekibinizi oluşturun",
  "38dddb483b": "Kuruma girin",
  "614d9c91eb": "Üyeleri davet edin",
  "97f1eca0aa": "Kuruma girin",
  "13a4939e90": "Kurumsal davet kabul",
  "a319e4ae0a": "Meslektaşları davet edin",
  "12e4da6bba": "Meslektaşlarınızı hemen davet edin",
  "bd885380f6": "Davet bağlantısı alınamadı",
  "5e626c4063": "SMS gönderildi",
  "3dc09e7cfd": "Geri kazanma talebinizin kurum adı sayısı üst sınırına ulaştı",
  "48318f41f9": "Üyeleri davet edin",
  "45441baac4": "{0} ile işbirliği yapmak için davet ediliniz",
  "e5847fbd67": "Bağlantıyı kopyalayın, üyeleri davet edin",
  "23101dd40a": "Çözüm size özel olarak hazırlanıyor",
  "71bb7e54a8": "Proje Yönetimi",
  "aff37c79cc": "Seçilen planı deneyin",
  "a97b174258": "2 meslektaşınızı daha davet edin, aşağıdaki kurumsal ayrıcalıkları ücretsiz kazanın",
  "253855849f": "Davet bağlantısını iş grubunuza paylaşarak meslektaşlarınızı davet edin",
  "57b0a2a63f": "Bağlantıyı kopyalayın, meslektaşlarınızı davet edin",
  "71c0a37ee1": "Kuruma girin",
  "f848c60e0e": "2 meslektaşınızı daha davet edin, aşağıdaki kurumsal ayrıcalıkları ücretsiz kazanın",
  "664e32b4fe": "Davet sayfası Kuruma girin",
  "872f14403a": "Meslektaşları davet edin",
  "1880e7deb9": "Meslektaşlarınızı hemen davet edin",
  "cc2a9aaf82": "Başarıyla oluşturuldu",
  "02a13e2583": "2 meslektaşınızı daha davet edin, aşağıdaki kurumsal ayrıcalıkları ücretsiz kazanın",
  "5d3593cdce": "Ekip bilgileri alınamadı",
  "c025113ea1": "Davet bağlantısı alınamadı",
  "b83bc1e485": "Bağlantı daveti",
  "0996ced9f6": "Üzgünüz, mevcut tarayıcınız bu QR kodunu indirmeyi desteklemiyor",
  "1e88451e31": "Davet bağlantısı kopyalandı",
  "bb969cabcd": "Kopyalama başarısız, lütfen yeniden deneyin",
  "15e1f79c7a": "Kuruma katılma başvurusu",
  "59c22b4ef8": "Bir davet bağlantısı aldınız",
  "0f0b392e60": "İlk Ekibinizi Oluşturun",
  "0437d07c43": "Şirket Adı",
  "41800c7bf1": "Lütfen yaratıcının adını girin",
  "1ec5999511": "Yaratıcı adı en fazla 8 karakter olmalıdır",
  "02da35b4e4": "Yaratıcı adı yalnızca Çince karakterler, harfler ve rakamlardan oluşabilir",
  "184e9f6616": "Lütfen iletişim numarasını girin",
  "9b587898ba": "Lütfen doğru biçimde bir iletişim numarası girin",
  "e68c164a02": "Lütfen e-posta adresinizi girin",
  "0b1de22df7": "Lütfen doğru biçimde bir e-posta adresi girin",
  "61026181ab": "İşletme Ruhsatı Gereklidir",
  "c3847e604e": "Dosya boyutu 10MB'yi aşıyor, lütfen başka bir dosya seçin",
  "49450f4ec7": "İsim İtiraz Formu Gereklidir",
  "39c3b8fa1d": "Gönderim Başarısız",
  "3ea44d7963": "Yükleme Başarılı",
  "5b1aa3c2c4": "Yükleme Başarısız",
  "7e7f81eaa3": "Yükleme başarısız, dosya 10MB'den büyük",
  "2ff1913de1": "Yükleme başarısız, dosya formatı .jpg, .jpeg, .png, .bmp, .pdf olmalıdır",
  "7951a879f2": "İşletme Ruhsatı Gereklidir",
  "66bda65057": "Dosya boyutu 10MB'yi aşıyor, lütfen başka bir dosya seçin",
  "8f2305a83d": "İsim İtiraz Formu Gereklidir",
  "55ff0c8c6e": "Gönderim Başarısız",
  "8dad6d950d": "Davet Bilgileri Alınamadı",
  "a5f0ac3a9a": "Oluşturma Başarılı",
  "4f1d069770": "Davet sayfası erişim utm parametresi {0} ve adı {1} olarak belirtildi",
  "f9578cfe6d": "İki adımlı kılavuz erişim utm parametresi {0} ve adı {1} olarak belirtildi",
  "e10d028405": "İki adımlı kılavuz pcoffice oluşturuldu",
  "8e22e4fcc4": "Davet bağlantısı kopyalandı",
  "3f327f9f37": "Kopyalama başarısız, lütfen tekrar deneyin",
  "bd1aecb265": "İptal",
  "b6abf9b19a": "Kabul et",
  "e910d9cc0f": "İptal",
  "37ab25522d": "Kabul et",
  "196b3eb9cf": "Taramayla Katıl",
  "2b81c52e20": "Resmi İndir",
  "62152fd9f3": "Bağlantı ile Davet Et",
  "e0a3725651": "Üzgünüz, tarayıcınız bu QR kodunu indirmeyi desteklemiyor",
  "8b7883b2c7": "Taramayla Katıl",
  "9e9a659ed5": "Resmi İndir",
  "0d55065a9a": "Bağlantı ile Davet Et",
  "487cf6a106": "Üzgünüz, tarayıcınız bu QR kodunu indirmeyi desteklemiyor",
  "78fd005d1f": "Lütfen cep telefonu numaranızı girin",
  "f909563857": "Bu numarayı kullanarak oluşturun",
  "a26a19f139": "Oluşturmayı İptal Et",
  "cc004ac9ee": "Cep Telefonu Numarası",
  "4df8c3c588": "Başka bir cep telefonu numarası girerek okul oluştur",
  "3151cabb3d": "Başka bir cep telefonu numarası girerek işletme oluştur",
  "56098a71eb": "Akıllı Doğrulamaya tıklayın ve kodu gönderin",
  "e96ec218e4": "Lütfen SMS doğrulama kodunu girin",
  "ce619a0225": "SMS doğrulama kodu gönderildi",
  "0e9863aaeb": "Yanlış doğrulama kodu, lütfen tekrar girin",
  "32dc8629e1": "Saniye sonra tekrar gönder",
  "e4eda9add5": "Tekrar gönder",
  "b007977564": "Onay bilgileri alınamadı",
  "d8852ffc9c": "Yönetici olmayan erişimi",
  "8a733a2574": "Mobil erişim",
  "9e8c152c4f": "PC erişimi",
  "2265a55e93": "Hizmet sözleşmesini kabul et",
  "80dabe5aa3": "Kılavuz oluştur",
  "7deee8bf5a": "İki adım kılavuzu DocsWeb oluşturuldu",
  "69eb501ecb": "Talebiniz geçersiz oldu, erişilemez",
  "aa1d9d98ad": "Yetersiz yetki, erişime izin yok",
  "fdf2fe129e": "Kuruluş Oluştur",
  "7f0ca0df6b": "Şirket Kur",
  "cc6ac2a93c": "Montajlı İki Adım Kılavuzu",
  "5d6c570bf0": "öncesinde İki Adım Kılavuzu",
  "a4eb8a192d": "Herkesin oluşturduğu takım",
  "4912e16a9d": "Şirket İsmi Geri Alındı",
  "41c4e87ef2": "Bağlantıya tıklayabilirsiniz",
  "5e630930c0": "Şirketi Yeniden Oluştur",
  "436a563524": "Zaten bir şirket oluşturduysanız, şu kılavuzu inceleyebilirsiniz",
  "0b6e7cbe7f": "Şirket Adı Nasıl Değiştirilir",
  "cb7bce0775": "Kılavuz şirket ismini değiştir",
  "3feadd3040": "Mevcut sürüm çok düşük, şirket kullanılamaz",
  "3cf23de936": "Yazılım versiyonunuz çok düşük, şirket fonksiyonları kullanılamaz. Lütfen uygulama marketinden yazılımınızı güncelleyin!",
  "a1c5d5d202": "Anladım",
  "e50183bd00": "WPS Bulut Belgeleri",
  "e5031ab679": "Güvenli, senkronize, işbirliği",
  "c870026dfc": "WeChat ile Giriş",
  "e7647cd875": "Telefon veya e-posta",
  "07b380074b": "QQ ile Giriş",
  "67921724dd": "Diğer yöntemler",
  "254da8a9f5": "Katılma/Şirket oluşturma sınırına ulaşıldı",
  "3648e4811b": "WPS Belgesine Gir",
  "dcd102b346": "Özel Takım Oluştur",
  "8b9b258cbf": "Lütfen buraya takım adını girin",
  "19bb6e0ded": "WPS üyeleri",
  "2d9fe8d938": "Ofis ayrıcalıkları, günlük ofis belgelerindeki sorunları çözmenize yardımcı olur, hemen deneyin!",
  "e8c1caa649": "Yerelden Yükle",
  "03641083a3": "Kişisel Belgelerden Taşı",
  "eecd3ab9b5": "Sonra söyle",
  "13b447b3a8": "Başka bir yığın",
  "3c2fc507fc": "Mevcut sürüm çok düşük, şirket kullanılamaz",
  "c3615d8134": "Yazılım versiyonunuz çok düşük, şirket fonksiyonları kullanılamaz. Lütfen resmi web sitesinden yazılımınızı güncelleyin!",
  "644a36e05b": "Güncelle",
  "d435105f21": "Katılma/Şirket oluşturma sınırına ulaşıldı",
  "73a286ceb0": "WPS Belgesine Gir",
  "c2cec645c0": "İptal",
  "b5f5b83c0f": "Kabul Et",
  "76ec352da5": "Meslektaşları davet et",
  "6a509e4487": "QR kodu indir",
  "940cc4a546": "Şirket oluşturulamaz",
  "78b2a62ea5": "Mevcut şirketlere katıl veya yeni şirket oluştur",
  "3a6da7f6f9": "Bu telefon numarası ile bağlanabilecek şirket sayısına ulaşıldı (maksimum 5)",
  "93bab52870": "Bu telefon numarasıyla zaten bir şirkete bağlısınız, aşağıdaki mevcut şirketlerden birini kullanarak giriş yapabilirsiniz:",
  "ce6e0adaf2": "Bağlı olan şirketlere giriş yapabilirsiniz:",
  "1ce200a92b": "Seç",
  "bb91ef2999": "Yeni Şirket Oluştur",
  "024e4a91e5": "Şirket İsmi Zaten Kayıtlı",
  "eb089a23a0": "Bu şirket ismi zaten kayıtlı:",
  "7646558701": "Yönetici:",
  "1d9c02bd33": "Kayıt Tarihi:",
  "919fc7805f": "Yukarıda belirtilen meslektaşlarınızı bulmaya veya onlarla iletişime geçmeye çalışmanızı öneririz.",
  "0ca71a9344": "Şirketi başka bir adla (daha sonra değiştirilebilir) oluşturabilir ve itirazda bulunabilirsiniz.",
  "e83a244e90": "Tıklayın ve nasıl başvuracağınızı öğrenin.",
  "d22bedfb21": "Tamam",
  "907b78b6e5": "Çalışma grubu veya takım adını girin",
  "7195b0ac1e": "Oluşturmak isteyebileceğiniz ekip",
  "60ed4f915e": "Sonraki Adım",
  "f5ba8dfb7b": "Kılavuzu Atla",
  "5c44a3ef68": "En fazla 100 karakter",
  "130c53fb20": "Adınızda yasal olmayan karakterler ve özel semboller / \\ ;:*? \" <> | % & bulunamaz",
  "e832d41acc": "İki adımlı rehberi atla",
  "80d9cf7177": "İki adımlı rehberi yenile",
  "0aebf80435": "İki adımlı rehberetiket tıklama",
  "e74f515977": "İki adımlı rehber handleSubmit",
  "308d2a53c9": "İki adımlı rehber grup oluştur",
  "dda2ed7e18": "İki adımlı rehber takım oluşturma başarısız",
  "ded3c35500": "Takım oluşturma başarısız",
  "4f18031bc1": "İki adımlı rehber şablon oluştur",
  "091e5cefcc": "İki adımlı rehber şablon oluşturma hatası",
  "58cf4e00f0": "Doğrulama kodu",
  "92abbf0385": "Doğrulama kodu gönder",
  "f0f9976ef9": "Telefon numaranızı giriniz",
  "a4ce99b1df": "Doğrulama kodu",
  "39d36e0f9f": "Onayla",
  "0fd8a01938": "Gönder",
  "9048a4e842": "Telefon numarası",
  "9afa1091eb": "Tekrar gönder",
  "58d787001f": "Okulu oluşturmak için başka bir telefon numarası girin",
  "450905a265": "Şirketi oluşturmak için başka bir telefon numarası girin",
  "f7386de3c6": "Aşağı açılır seçim",
  "27aa05a92c": "Hizmet sözleşmesini kabul et",
  "80af61cb57": "Önceki sayfaya dön",
  "50149b8d4f": "Başvuru sahibi adı",
  "e6756f8749": "Lütfen adınızı giriniz",
  "3cbd51a2b1": "Ad en az 2 karakter olmalı, lütfen 2-10 karakterlik bir ad giriniz",
  "4f79b4813f": "Ad yalnızca Çince karakterler, rakamlar ve İngilizce harfleri destekler.",
  "71d3e75983": "Sık kullanılan telefon numarası",
  "afe5149035": "Lütfen sık kullandığınız telefon numarasını giriniz",
  "1e9270b50f": "Lütfen sık kullandığınız 11 haneli telefon numarasını giriniz",
  "ff5dc98dfb": "Atla",
  "165be2ab43": "Önceki adıma geri dön",
  "231d8a335a": "Hizmet sözleşmesini kabul et",
  "1cad008ffc": "Şirket adı {0} zaten kayıtlı, lütfen başka bir ad kullanın",
  "c6e274fcab": "Sözleşme Onayı",
  "b9352504bb": "Sözleşme açılır penceresini kapat",
  "8409e99ad0": "Sözleşme açılır penceresini aç",
  "1593c6dd95": "Gönder",
  "4f44a9de22": "SMS doğrulamasını aç",
  "26b70c68b8": "Atla, doğrudan şirkete geç",
  "a8bebcb302": "Önceki sayfaya dön",
  "c800b4fec5": "Davet sayfası Base Mounted",
  "38b396d5b0": "Davet sayfası docsWeb Mounted",
  "2eb7f9a9f1": "İtirazınız başarıyla gönderildi",
  "2c6f3590fb": "Sonuçları üç iş günü içinde e-posta adresinize göndereceğiz",
  "2ea3eff708": ", lütfen kontrol edin.",
  "53acfba22c": "Meslektaşları Şimdi Davet Et",
  "4e6d282f4f": "Kuruma Katılmak İçin Davet Edin",
  "5f72f4b936": "Meslektaşları Şimdi Davet Et",
  "e5383077ba": "Kurumsal Adı Bulun",
  "06e3fa2350": "Sorgulama Sonucunda,",
  "653a263b5e": "oluşturucu olarak",
  "769f57269f": "oluşturucunun telefon numarası",
  "09a224695e": "Lütfen bu işletme oluşturucusunun meslektaşınız olup olmadığını onaylayın",
  "3beda6c149": "Eğer meslektaşınız ise, onunla iletişime geçebilirsiniz",
  "5c74dd10d1": "İşletme Adını Değiştir veya Süper Yöneticiyi Devret.",
  "da504edb0f": "Eğer meslektaşınız değilse, şirket adını geri almak için aşağıdaki düğmeye tıklayabilirsiniz.",
  "39194faaf1": "İşletme Adını Kurtarmaya Devam Et",
  "e22b829e90": "Kopyalama Başarılı",
  "6e1b44752a": "TXT Değeri",
  "79881b1d7a": "Meslektaşı Hemen Davet Et",
  "a5344a45f9": "Sağ üst köşeye tıklayın ve arkadaşınıza göndermeyi seçin",
  "a4954a5b08": "Meslektaşı Hemen Davet Et",
  "8e3a1625fb": "İşletme Adını Kurtar",
  "bf8b8c7005": "İşletme Ruhsatını Yükle",
  "bfd44a66c9": "Tıklayarak Seçin",
  "d503f20925": "Lütfen işletme ruhsatının taranmış bir kopyasını veya fotoğrafını yükleyin",
  "cbebe043c5": "JPG, JPEG, PNG, BMP, PDF formatlarını destekler, boyut 10 MB'ı geçmemelidir.",
  "9650b96d7d": "Aynı Ad Başvuru Bilgi Formunu Yükle",
  "c3b8ae46d3": "Lütfen aynı ad başvuru bilgi formunun taranmış bir kopyasını veya fotoğrafını yükleyin",
  "9e325a9e09": "Bilgi Formu Şablonunu İndirin",
  "a4711aae88": "Başvuruyu Gönderin",
  "3a5cc1441e": "Doğrulama devam ediyor...",
  "0bd7bf8511": "Şu anda alan adınızı doğrulayamıyoruz, alan adı barındırma sağlayıcınızın bilgilerinizi güncellemesi için biraz daha beklemeniz gerekebilir. Bir süre bekledikten sonra hala tepki yoksa, lütfen tekrar doğrulamayı deneyin veya alan adını değiştirin.",
  "fae48d554b": "Alan Adı Kontrol Ediliyor",
  "5e1779a0ca": "doğrulama kaydı, bu sayfayı kapatabilir ve daha sonra kontrol etmek için geri dönebilirsiniz.",
  "ca85f8b836": "Kurumsal Sürümüne Hoş Geldiniz",
  "2570e0f00b": "Giriş Başarısız Oldu",
  "40d16a007e": "Kişisel hesabınız otomatik olarak bağlandı",
  "81376b92e4": "{0} giriş yöntemi, lütfen kurumsal hesabı değiştirmek için yeniden giriş yapın.",
  "ba679ba739": "Tamam, Giriş Yap",
  "c05f64c6c6": "{0} ardından otomatik olarak giriş sayfasına yönlendirin",
  "c329ccef3a": "Giriş Başarısız Oldu",
  "e370f9afb1": "Kişisel hesabınız otomatik olarak bağlandı",
  "410cf42585": "giriş yöntemi, lütfen kurumsal hesabı değiştirmek için yeniden giriş yapın.",
  "062d48aece": "Tamam, Giriş Yap",
  "95a105d412": "ardından otomatik olarak giriş sayfasına yönlendirin",
  "2d000d5a6d": "Üyeye paylaşım bağlantısı gönderin, üye açtıktan sonra katılmak için başvurabilir",
  "8861b6e90d": "İşletmeye Gir",
  "25b9f72fda": "Sayfa Parametre Hatası",
  "1c76123efc": "Davet Bağlantısı Alma Başarısız",
  "6caba48b76": "Atla",
  "f66379c650": "Sayfa Parametre Hatası",
  "c45021de2a": "Oluşturma Başarısız Oldu",
  "011d470126": "Platform bilgilerinizi sürekli korumaktadır",
  "f1a44d9151": "Platform, uluslararası BSI tarafından yayımlanan ISO27001, ISO27701 sertifikalarını almış ve ulusal üç düzeyde bilgi güvenliği sertifika değerlendirmesinden geçmiştir--",
  "255ea5dff7": "Güvenlik Beyaz Kitap",
  "bb55b124f2": "Şirket Sunumu Oluştur",
  "61e24974a3": "Şirket Strateji İçeriği Oluştur",
  "bfdf78febe": "Sonraki Adım: Bilgileri Tamamlayın",
  "c4aa2d2d60": "Çalışma Grubu veya Proje Adı Girin",
  "b69765ab64": "Herkesin Oluşturduğu Takımlar",
  "9657d9408b": "Başka Bir Grup Göster",
  "e21da8c16a": "Sonraki Adım",
  "224ef5cc9f": "Kılavuzu Atla",
  "641f58c8f6": "Mevcut Şirket Üyelerinin Takım Oluşturmasına İzin Verilmiyor, Lütfen Yöneticinizden Oluşturmasını Talep Edin",
  "efea622752": "Bağlantıyı Kopyalayın ve Meslektaşlarınızı Davet Edin",
  "fd5b40a9fd": "{0}‘e Katılmaya Davetlisiniz, Birlikte Çalışın",
  "b04dd2f10a": "Davet Bağlantısı Kopyalandı",
  "d1606a1b1a": "Kopyalama Başarısız, Lütfen Tekrar Deneyin",
  "0d59f3db83": "Proje Departmanı veya Takımı Girin, Örneğin 'Satış Departmanı'",
  "9429513d34": "Kılavuza Gerek Yok",
  "b54a20b1ff": "Oluşturma Başarısız",
  "093fa0fb74": "Giriş Yetkilendiriliyor...",
  "b383b136f4": "Şirket Projesi Başlatma",
  "b6b21b388b": "Şirket Adı Zaten Kayıtlı",
  "285dc68c10": "Bu Şirket Adı Kayıtlı: ",
  "1bf685b89d": "Yönetici: ",
  "7b4297edcc": "Kayıt Zamanı: ",
  "fa51ea19fc": "Yukarıdaki Meslektaşınızı Bulmak ve İletişime Geçmek İçin Bir Deneme Yapmanızı Öneririz.",
  "e3678a996d": "Ayrıca Geçici Olarak Başka Bir İsim Kullanarak Şirketi Oluşturabilirsiniz (Daha Sonra Değiştirilebilir) ve Başvuruda Bulunabilirsiniz.",
  "5969bc8071": "Tamam",
  "ba4cf699df": "Şirket Adını Geri Al",
  "afecee4eb4": "Adınız",
  "a8bdebc614": "Lütfen Adınızı Giriniz",
  "5bbeb38a66": "Telefon Numarası",
  "b4f7b44b7a": "Lütfen Telefon Numaranızı Giriniz",
  "cac2913686": "İletişim E-posta",
  "23d3bb3a42": "Lütfen İletişim E-posta Giriniz",
  "ea106a393c": "Şirket Ticari Sicil Belgesini Yükle",
  "f74131d71e": "Seçim Yapmak İçin Tıklayın",
  "53749c51c5": "Lütfen Şirket Ticari Sicil Tarama veya Fotoğrafını Yükleyin",
  "c00f2ea171": "JPG, JPEG, PNG, BMP, PDF Formatlarını Destekler, Boyut 10 MB'yi Geçmemelidir.",
  "57ec07fa97": "Aynı İsim Temyiz Formunu Yükleyin",
  "8eb0606e94": "Lütfen Aynı İsim Temyiz Formu Tarana veya Fotoğrafını Yükleyin",
  "f59e76c0b0": "Bilgi Formu Şablonunu İndirin",
  "030bd26fa4": "Başvuruyu Gönder",
  "0a602dc727": "Verileri Güvenli Depolama",
  "9138f28acf": "Dosya Paylaşımı İşbirliği",
  "b3a306cf90": "Uyumlu Lisanslı Kullanım",
  "973c53f725": "Adı Değiştirmenizi Öneririz; Kayıt Olduktan Sonra Kurumsal Doğrulama ve İsim Güncelleme Gönderebilirsiniz",
  "f886f5e92f": "Adı Değiştirmenizi Öneririz; Kayıt Olduktan Sonra Şirket Doğrulaması ve İsim Güncelleme Gönderebilirsiniz",
  "b8051702a3": "Bu İsim Hassas Kelimeler İçeriyor, Lütfen İsmi Değiştirin veya Müşteri Hizmetleriyle İletişime Geçin",
  "d73881f7d4": "Şirket İsmi Koruma Altında",
  "dc7e58e320": "Şirket İsmi Koruma Altında, Kullanım Öncesi Başlık Bilgisinin Doğrulanması Gerekir. İsim Değiştirmenizi veya Kayıt Yaptıktan Sonra Şirket Doğrulaması ile Adı Kullanmanızı Öneririz.",
  "20c3bc070c": "Onayla",
  "c4278e5f28": "Yetersiz Yetki",
  "9217efae21": "Giriş yaptığınız hesabınızın oluşturma yetkisi yok, lütfen satış personeliyle iletişime geçin",
  "52ff08f2ad": "Kurum adı koruma altındadır, lütfen şirket adını düzenleyin",
  "79386ae280": "6 Haneli Doğrulama Kodunu Girin",
  "d7b2c5a41b": "Doğrulama kodu gönderildi",
  "ce2e1c26f7": "(10 dakika geçerlidir)",
  "59d338903f": "{0} saniye sonra doğrulama kodunu yeniden alabilirsiniz",
  "5aadd14136": "Doğrulama Kodunu Yeniden Al",
  "90f5c93432": "Bu İsim Zaten Kaydedilmiş",
  "1677072f4a": "Daha fazla bilgi ekleyebilir veya başka bir adla kayıt yapabilirsiniz",
  "3b8459fb1e": "Hızlı Doldurma:",
  "6f38edbcb1": "Bu Adı Kullanarak Kaydol",
  "8406c81e2d": "Şube",
  "29d323fa85": "Alt Merkez",
  "4f0e806e02": "Muhasebe Bölümü",
  "3f935efb6b": "Hizmet Sözleşmesini Kabul Et",
  "b42241be05": "Henüz Değil",
  "99de4b33b7": "Onayla",
  "7f867e7395": "Başka Bir Telefon Numarası Kullanarak Şirket Oluştur",
  "0d51a8f7a6": "Oluşturma İşlemine Devam Et",
  "8bdaecf2e5": "Lütfen Telefon Numaranızı Girin",
  "565ae60c8a": "Lütfen Adınızı Girin",
  "f76e06d0e7": "Lütfen Telefon Numaranızı Girin",
  "7b0fca5255": "Lütfen Doğrulama Kodunu Girin",
  "68026d2d25": "Kurumsal Sürümü Kullanmaya Hoş Geldiniz",
  "d25b5541be": "Ücretsiz Oluştur",
  "32cfd73733": "Lütfen Takım, Şirket veya Kuruluş Adını Girin",
  "4cf83dc4a0": "Bir Dakikada Hızlı Oluşturma, Meslektaşlarınızla Verimli İşbirliği Yapın",
  "d320d37116": "Ücretsiz Takım/Şirket Oluşturun",
  "c54b475dd2": "Kullanıcı Sözleşmesi",
  "190d54e616": "{0} Şirketi",
  "8c1b768ac4": "Akıllı Doğrulama Başarısız",
  "d74eab0f35": "Şirket adınızın bilgi girişi platform standartlarına uygun değil, lütfen düzenledikten sonra yeniden deneyin",
  "0f3d62dd4f": "Adınızın bilgi girişi platform standartlarına uygun değil, lütfen düzenledikten sonra yeniden deneyin",
  "647cf2211b": "Mevcut telefon numarası ile oluşturma desteklenmiyor, lütfen başka bir numara kullanın",
  "b63d96cdae": "Bilgi girişi platform standartlarına uygun değil, lütfen düzenledikten sonra yeniden deneyin",
  "2dbbe8e43f": "Mevcut telefon numarası ile oluşturma desteklenmiyor, lütfen düzenleyin",
  "b18abc5de6": "Bağlı Telefon Numarası Yok",
  "f5233dae6f": "Başka Bir Numara Kullanarak Oluşturun",
  "4167c8b88d": "Mevcut telefon numarası aşağıdaki durumlarla karşılaşabilir, lütfen başka bir numara kullanarak oluşturmayı deneyin. Sorularınız varsa, lütfen müşteri danışmanı ile iletişime geçin.",
  "a8a2433c4d": "WeChat Tarayıcı ile ekleyin, müşteri hizmetlerine danışın",
  "444a639c09": "Biliyorum",
  "69a097057f": "Şu anki telefon numarası <#BB2726>sanal operatör numara grubuna<#BB2726> aittir",
  "4370b06fd0": "Mevcut Telefon Numarası <#BB2726>Şüpheli Kullanım Davranışı<#BB2726> İçeriyor",
  "8c49e1dc4a": "İnsan-Makine Doğrulama Gerekiyor",
  "4b8ba7d8cc": "Yeni Nesil İş Üretkenlik Platformu",
  "81be771e17": "🎉Kurumsal Başarıyla Oluşturuldu! Bilgilerinizi Tamamlayın ve Özel Hizmetler Alın",
  "461125b057": "Belgelerde ve bilgilerdeki yönetim, ekipte yapılabilir. Ekip üyeleri belgelere kolaylıkla göz atabilir ve düzenleme/indirme izinleri ayarlayarak veri güvenliğini sağlayabilirler.",
  "c3eb25029b": "Şirketiniz/ekibinizin büyüklüğü",
  "049f8401ec": "5 kişiden az",
  "c81896349e": "6-20 kişi",
  "7357daac4e": "21-50 kişi",
  "f0e65a0a29": "51-100 kişi",
  "b9fac8204a": "101-200 kişi",
  "62d73dddaf": "201-500 kişi",
  "3bcdaf7160": "501-2000 kişi",
  "ab0b2333fe": "2000 kişiden fazla",
  "4f756eedc8": "Rolünüz nedir",
  "3ba0b502c3": "Genel Müdür",
  "702099cc72": "Finans",
  "843b603162": "Satın Alma",
  "8b414a9b44": "İnsan Kaynakları/İdare",
  "92486b2908": "Satış",
  "ac4e7fb063": "Organizasyonunuzun ofis yazılımı bütçesi/satın alma planı var mı?",
  "37634c72dc": "6 ay içinde",
  "bd94b6deec": "1 yıl içinde",
  "713f4aad5c": "Düşünülüyor",
  "c5ea095a4d": "Plan yok",
  "2409099a69": "<img src=\"https://ks3-wpsplus-prod.wpscdn.cn/e2546275-3953-40b4-8933-9ff6f0a1aeb4.png\"> Bir Takım Oluşturun, Üyeleri Davet Edin ve Birlikte İşbirliği Yapın",
  "9d27dc2d90": "Ekip adınızı veya yakın zamanda takip edilen projelerinizi girebilirsiniz.",
  "de19c8509a": "Muhtemelen şunları oluşturacaksınız:",
  "1a84699223": "Satış Bölümü",
  "efab59502b": "Ürün Bölümü",
  "7e599b3713": "Güney Operasyon Bölümü",
  "bf494779c2": "Satın Alma Bölümü",
  "f3a60ab34d": "İdari Bölüm",
  "bbc50c1ac8": "Kuzey Finans Bölümü",
  "32629e3dac": "Ürün Finans Bölümü",
  "5524d354ba": "BT Bölümü",
  "0ccda29a0d": "🎁<span style='color: rgb(206,131,62);'>Yeni Başlayan Avantajlarınızı Açtınız!</span> 3 Kişi Daha Davet Edin, <span style='color: rgb(206,131,62);'>4T Depolama, WPS AI</span> Avantajları Kazanın",
  "939eb98492": "<span style='color: rgb(206,131,62);'>50 Kişilik Sınırı ve 4G Tek Dosya Yükleme Avantajını Açtınız</span>. 3 Kişi Daha Davet Edin, 30 Günlük WPS AI, 4T Depolama Fırsatları Kazanın",
  "136c26d941": "Aşağıdaki bağlantıyı kopyalayın, üyeleri ekibe davet edin.",
  "3de5c12558": "Bağlantıyı kopyalayın, iş arkadaşlarını davet edin.",
  "a5d64b14f3": "Şirket Bilgileri Kılavuzu",
  "b8f2492701": "Şirket Bilgi Toplama",
  "1f9d053dc0": "Ekip Şablonu Oluşturun",
  "0e83c79a88": "Üyeleri Davet Edin",
  "821fc1906a": "Şirkete Giriş",
  "463e14ae9c": "Lütfen ekibi seçin",
  "690f0cdb9e": "İkonu tamamla",
  "c340522a17": "Önceki Adım",
  "f9355c72ef": "Atla",
  "bd6c09ebbb": "Sonraki Adım",
  "2a2603cd3f": "İş arkadaşlarına davet göndermek için QR kodunu tarayın",
  "411e64907a": "Kopyala",
  "b0d988cf23": "İndir",
  "e3c0b650ac": "Kopyalama başarılı",
  "713ac624b4": "WPS 365 Kullanımınıza Hoş Geldiniz",
  "b8fff97849": "Geçersiz hedef ögesi",
  "02acdcf296": "html2canvas dönüştürme başarısız, canvas oluşturulmadı",
  "a76988c496": "canvas'ı blob'a dönüştürme başarısız",
  "af89584edf": "Pano API kullanılamıyor",
  "f90263bbde": "Resim kopyalama başarısız",
  "71b05319da": "HTML'i canvas'a dönüştürme başarısız",
  "38852999fe": "Bilgi kaydetme başarısız",
  "4a4c621d07": "Takım oluşturma başarısız, lütfen daha sonra tekrar deneyin",
  "d239a23994": "Geçerli sayfa yalnızca kurumsal hesaplar tarafından erişilebilir, lütfen önce kurumsal hesabınıza giriş yapın.",
  "d93bfb7fb9": "İçeriği girin",
  "42b81a66c4": "Uzunluk 2 ile 100 karakter arasında olmalıdır",
  "76d33733db": "/ \\ ; : * ? \" < > | % & gibi özel karakterler içeremez",
  "dc55d1f62f": "Deneyim için Git",
  "b25233cba0": "Belge İşbirliği + Anlık Mesajlaşma, Verimli Çalışmanın Yeni Yolu",
  "f0e563652d": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Ortak Çalışma Grubu Sohbetini Başlatın, Belge Paylaşımı Güvenli ve Kolay",
  "1e484cce68": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/lingxi_normal.png\"> Akıllı AI Asistanı, Ofis Kullanımı İçin Doğmuş Bir Akıllı Yardımcı",
  "e338385bc9": "Yerleşik Office Akıllı Asistanı, AI ve ofis yazılımlarıyla derinden entegre edilmiş, herkese AI Asistanı sunar",
  "7ae1f3b1c6": "Dosya (klasör) aktarımı tamamlandı, aktarım sonucunu 'Benim Bulut Belgelerim'de görebilirsiniz",
  "85db2a024a": "Dosya (klasör) aktarım hatası, lütfen daha sonra tekrar deneyiniz",
  "9ff74c802a": "Intel Çip Versiyonunu İndir",
  "ab44928f02": "Apple Çip Versiyonunu İndir",
  "a08d937c38": "Dosya (klasör) yükleniyor, tamamlandığında 'Benim Bulut Belgelerim'de görebilirsiniz",
  "68db1829fa": "Sadece kişisel hesaptan aktarma desteklenir, lütfen kişisel hesabınıza giriş yapıp tekrar deneyin.",
  "1185a7c7ab": "20 kişiden az",
  "e2bcc252c9": "21-300 kişi",
  "3c4842f1ea": "301-1000 kişi",
  "1bbee64cfa": "1000 kişiden fazla",
  "388ff4a035": "Öğretmen",
  "d341b1d794": "Öğrenci",
  "bfb2ee4148": "Diğer",
  "f6450c3f31": "Proje Yönetimi",
  "b87fd33a0d": "Yıllık Plan",
  "0dd45a1c14": "Çalışan Performans Yönetimi",
  "67fa01cac6": "Pazarlama Etkinlikleri",
  "6dd82cc031": "Çalışan İşe Alımı",
  "a7edaed91d": "Eğitim Sunumları",
  "bf12b7efb0": "Eğitim Planı Yönetimi",
  "c35ae8f358": "Ürün Belgeleri",
  "343f236a78": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/dbsheet.png\"> WPS Çok Boyutlu Tablo, özel iş sistemi kurmak için görsel olarak yapılandırın",
  "72286d5519": "👏Önerilen Şablonlar",
  "0bc00ee949": "Gereksinim Hatası Yönetimi",
  "e22f3d56f7": "İçerik Yaratma Yönetimi",
  "dd439de3dd": "Müşteri Yönetim Sistemi",
  "fbb2bbf82e": "Sınav Hazırlık Planı",
  "0645b908bc": "Maaş Tabloları Sorgulama",
  "813b3d3d7e": "OKR Yönetimi",
  "918e33d5bd": "Tek Tıkla Oluşturma",
  "ebf9cfb7ef": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/import_files.png\"> Yaygın Belgeleri İçe Aktarın, daha kolay kullanın",
  "c58f28713c": "Yerelden İçe Aktar",
  "9d6a0a4370": "Office Yaygın Dosya Formatlarını Destekler",
  "54c48aee85": "Dosya Seç",
  "c5b593e452": "Kişisel Hesaptan İçe Aktar",
  "4bdcd9d4c5": "Tek Tıkla Kişisel Hesap Belgeleri, Takımlar, Klasörleri İçe Aktarın",
  "99b2968905": "Yetkilendir İçe Aktar",
  "472f818a23": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> WPS Ekipleri İstemcisini İndir",
  "fe46574227": "Belge İletişimi + Anlık Mesajlaşma, Verimli Çalışmanın Yeni Yolu",
  "beefe5a09b": "Hemen İndir",
  "278839c7b1": "<img src=\"https://vasvip-pub.wpscdn.cn/prod/SAAS-UG/atomic_guidance/icon/woa_logo_l.png\"> Zengin Güvenlik Ayarları, Veri Güvenliğini Sağlar",
  "b4e70dbeab": "WPS Yılların Belge Güvenliği Deneyimi, Kurumsal Kritik Verileri Koruma Altında",
  "42dc772619": "Dosya Çok Büyük, Lütfen Giriş Sayfasında Yeniden İçeri Aktarmayı Deneyin",
  "a052564e47": "Oluşturma Hatası, Lütfen Daha Sonra Tekrar Deneyin"
}